"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseStore = void 0;
const alt_1 = __importDefault(require("../alt"));
/**
 * @param A type of Action Handlers object
 * @param P type of Public Methods object
 * @param S type of State object
 * @param Src type of Async Methods object
 */
class BaseStore {
    constructor() {
        this.bindListeners(this.getActionsHandlers());
        this.exportPublicMethods(this.getPublicMethods());
        this.exportAsync(this.getSource());
    }
}
exports.BaseStore = BaseStore;
/**
 * Helper to create a typed Alt Store
 * @param {StoreConstructor<A extends HandlerInterface, P extends HandlerInterface, STATE extends Object, SOURCE extends Source<any>>} storeClass
 * @param name
 * @return {StoreInstance<P extends HandlerInterface, STATE extends Object, SOURCE extends Source<any>>}
 */
function createStore(storeClass, name) {
    return alt_1.default.createStore(storeClass, name);
}
exports.default = createStore;
